import { Box, Button } from '@mui/material'

export const NavigationButtons = () => {
  return (
    <Box sx={{ my: 6 }} textAlign="center">
      <Button variant="contained" size="large" type="submit" sx={{ width: 180 }}>
        次へ
      </Button>
    </Box>
  )
}
